import styled from 'styled-components';

export const OpportunityInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 500px;

  margin-bottom: 20px;

  @media screen and (max-width: 576px) {
    width: 100%;
    padding: 0 12px;
  }
`;
